import { useCallback } from 'react';
import { useNavigate, useParams, type NavigateOptions } from 'react-router';
import { locales, defaultLocale, type Locale } from '@/i18n/config';

export function useLocalePrefix(): string {
  const { locale } = useParams<{ locale: string }>();
  const valid = locales.includes(locale as Locale) ? locale : defaultLocale;
  return `/${valid}`;
}

export function useLocaleNavigate() {
  const navigate = useNavigate();
  const prefix = useLocalePrefix();

  return useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }
      const path = to.startsWith('/') && !locales.some(l => to.startsWith(`/${l}/`))
        ? `${prefix}${to}`
        : to;
      navigate(path, options);
    },
    [navigate, prefix],
  );
}
